import * as _ from "underscore";

import compositeViewMixin from "compositeViewMixin";
import * as localAPI from "localAPI";
import models from "models/models";
import * as mustcache from "mustcache";
import SignupView from "views/SignupView";

export const name = "webReaderSignInPage";
export const showHeader = true;

let subviewManager;

export const render = async (element, renderedCallback) => {
  element.html(
    mustcache.render("webReaderSignInPage", {
      localMode: await localAPI.isLocalMode(),
    })
  );

  subviewManager = _.extend({}, compositeViewMixin);

  subviewManager.addSubview(
    new SignupView({
      models,
      el: element.find(".sign-in-view"),
    })
  );

  renderedCallback();
};

export const close = () => {
  subviewManager.removeSubviews();
};
